import { Outlet } from 'react-router-dom';

import Card from './Card';

type PropsCenterCardLayout = {
  title?: string;
  children?: JSX.Element;
}

export function CenterCardLayout({ children, title }: PropsCenterCardLayout) {
  return (
    <section className="container h-100">
      <div className="row justify-content-center align-items-center h-100">
        <div className="col-auto">
          <Card title={title}>
            <>
              {children}
              <Outlet />
            </>
          </Card>
        </div>
      </div>
    </section>
  );
}

export default CenterCardLayout;
